module.exports = __webpack_public_path__ + "img/J12621.5453caa9.png";